import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

/**
 * PrimeVue-Theme an die Design-Tokens aus dem Handoff angepasst.
 *
 * Vollstaendiger Token-Satz: siehe `docs/design-reference/src/style.css`.
 * Was hier definiert ist, ueberschreibt PrimeVue-Defaults; alles andere
 * uebernimmt PrimeVue von Aura.
 *
 * Primary-Palette ist die Amber-Skala des CR-Rebrand (Logo-„C"); siehe
 * Kommentar in `style.css` ueber `--accent`. Aura nutzt primary-900/950
 * auch fuer Surface-Akzente und elastic-Scroll-Fallbacks — wenn die Skala
 * nicht zur Marke passt, blitzt der falsche Ton bei Bounce-Scroll auf
 * Safari durch.
 */
export const PartroomPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fff7e6',
      100: '#ffead0',
      200: '#ffd6a2',
      300: '#ffc375',
      400: '#ffb157',
      500: '#ffcc83', // CR-Rebrand: Amber-Hi-Vis (== --accent in style.css)
      600: '#e6a85a',
      700: '#c28346',
      800: '#985f33',
      900: '#704325',
      950: '#3d2415'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f6f7f9',
          100: '#f2f3f6',
          200: '#e2e5ea',
          300: '#d4d8de',
          400: '#a8aeb8',
          500: '#8a909b',
          600: '#5a616b',
          700: '#444a54',
          800: '#363b43',
          900: '#2a2f39',
          950: '#1c2027'
        }
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '#edeff2',
          100: '#dadde2',
          200: '#aab1bd',
          300: '#7a8290',
          400: '#5b6470',
          500: '#444a54',
          600: '#3a414d',
          700: '#2a2e36',
          800: '#23272e',
          900: '#1c2027',
          950: '#14171c'
        }
      }
    }
  }
})
